/** What a create/save RFI request carries besides the RFI itself. */
export interface RfiCreateRequest {
  type?: string;
  /** Set by the Drawings viewer's Add to (W20): close the panel and keep the user on the sheet. */
  stayInPlace?: boolean;
}

interface RfiCreateHooks {
  closePanel(): void;
  showRfi(data: unknown): void;
  navigate(queryParams: Record<string, string>): void;
}

/**
 * After an RFI is saved: by default the panel shows the saved RFI on the RFIs tab. A request made from another screen
 * that asked to stay (the sheet viewer) only closes the panel, so that screen keeps its state.
 */
export function afterRfiCreated(request: RfiCreateRequest | null | undefined, data: unknown, hooks: RfiCreateHooks): void {
  if (request?.stayInPlace) {
    hooks.closePanel();
    return;
  }
  hooks.showRfi(data);
  hooks.navigate({ tab: 'rfis', subTab: 'details' });
}
